import React, { useEffect, useState } from 'react';

import './index.less';

import { defaultApi } from '../../apis';
import { AboutInfo } from '../../gamma-api';
import IbTooltip from '../common/IbTooltip';
import IbTypography from '../common/IbTypography';

const MAIN_CLASS_NAME = 'app-version';
const TOOLTIP_CLASS_NAME = `${MAIN_CLASS_NAME}__tooltip`;
const APP_VERSION_PREFIX = 'ver. ';

const AppVersion: React.FC = () => {
  const [aboutInfo, setAboutInfo] = useState<AboutInfo>();

  useEffect(() => {
    const loadAboutInfo = async () => {
      try {
        const response = await defaultApi.getAboutInfoInfoApplicationAboutGet();
        setAboutInfo(response.data);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('Failed to load about info: ', err);
        setAboutInfo(undefined);
      }
    };

    loadAboutInfo().finally();
  }, []);

  const versionText = aboutInfo?.version ? `${APP_VERSION_PREFIX}${aboutInfo.version}` : `${APP_VERSION_PREFIX}...`;

  return (
    <div className={MAIN_CLASS_NAME}>
      <IbTooltip className={TOOLTIP_CLASS_NAME} placement="top" title={versionText}>
        <IbTypography.Paragraph ellipsis light type="descriptor">
          {versionText}
        </IbTypography.Paragraph>
      </IbTooltip>
    </div>
  );
};

export default AppVersion;
